import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { login as apiLogin, logout as apiLogout, getMe, updateMe as apiUpdateMe } from '../api/auth';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    try {
      const me = await getMe();
      setUser(me);
    } catch {
      // sem cookie ou expirado — não autenticado
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadUser(); }, [loadUser]);

  useEffect(() => {
    const handler = async () => {
      try { await apiLogout(); } catch {}
      setUser(null);
    };
    window.addEventListener('auth:logout', handler);
    return () => window.removeEventListener('auth:logout', handler);
  }, []);

  const login = async (email, senha) => {
    await apiLogin(email, senha);
    const me = await getMe();
    setUser(me);
    return me;
  };

  const logout = async () => {
    try { await apiLogout(); } catch {}
    setUser(null);
  };

  const refreshUser = async () => {
    const me = await getMe();
    setUser(me);
    return me;
  };

  const updateMe = async (data) => {
    const me = await apiUpdateMe(data);
    setUser(me);
    return me;
  };

  const isAdmin = user?.perfil === 'admin';
  const isFenix = user?.perfil === 'fenix' || isAdmin;

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isFenix, isAdmin, refreshUser, updateMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
